module.exports = __webpack_public_path__ + "static/media/233-madeira.a3aa04e5.svg";